import { Component, OnInit } from '@angular/core';
import { AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { WorkSections, Departments, JobTitles } from '../../hrCommon';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';

@Component({
  selector: 'work-sections-table',
  templateUrl: './work-sections-table.component.html',
  styleUrls: ['./work-sections-table.component.css'],
  providers: [MainGridService]
})

export class WorkSectionsTableComponent implements OnInit {

  tablePermissions: AimsCommonTablePermissions = {
    create: false, // Set below in constructor
    update: false, // Set below in constructor
    delete: false,
  };
  initialTableElement;
  initialDepartmentsTableElement;
  initialJobTitlesTableElement;

  workSections: Observable<any>;
  workSectionsHeader: AimsCommonTableHeader[] = [
    { key: 'rowExpand', label: '', type: 'rowExpand', filter: false },
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'workSection', label: 'Work Section', type: 'string', validatorOrOpts: [Validators.required, Validators.maxLength(22)] },
    { key: 'departmentId', label: 'Department', type: 'dynamic', filterType: 'dynamic', validatorOrOpts: [Validators.required] },
    { key: 'leadId', label: 'Work Section Lead', type: 'dynamic', filterType: 'dynamic' }
  ];

  mainDepartmentsService;
  departmentsResults: any[];
  departments: Observable<any>;
  departmentsHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'department', label: 'Department', type: 'string', validatorOrOpts: [Validators.required, Validators.maxLength(50)] },
    { key: 'managerId', label: 'Department Manager', type: 'dynamic', filterType: 'dynamic', validatorOrOpts: [Validators.required] },
    { key: 'departmentCode', label: 'Department Code', type: 'string', validatorOrOpts: [Validators.required, Validators.maxLength(50)] },
  ];

  mainJobTitlesService;
  jobTitlesResults: any[];
  jobTitles: Observable<any>;
  jobTitlesHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'jobTitle', label: 'Job Title', type: 'string', width: 200, validatorOrOpts: [Validators.required, Validators.maxLength(50)] },
    { key: 'workSectionId', label: 'Work Section', type: 'dynamic', filterType: 'dynamic', validatorOrOpts: [Validators.required] },
    { key: 'jobCategoryId', label: 'Job Category', type: 'dynamic', filterType: 'dynamic', events: { filterAndSortCompare: (term, el) => term === el.jobCategoryId }, validatorOrOpts: [Validators.required] },
    { key: 'unionAffiliationId', label: 'Union', type: 'dynamic', filterType: 'dynamic', validatorOrOpts: [Validators.required] },
    { key: 'payrollCode', label: 'Payroll Code', type: 'number', validatorOrOpts: [Validators.required] },
    { key: 'onSeniorityList', label: 'On Seniority List', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'color', label: 'Color', type: 'dynamic', filter: false }
  ];

  departmentValues = this.transferHttp.getSingle('Common/GetAllDepartmentsForDropdown');
  leadValues = this.transferHttp.getSingle('Common/GetActiveEmployeesForDropDown');
  managerValues = this.transferHttp.getSingle('hr/GetManagersForDropdown');
  jobTitleValues = this.transferHttp.getSingle('Common/GetAllJobTitlesForDropdown');
  workSectionValues = this.transferHttp.getSingle('Common/GetAllWorksectionsForDropdown');
  jobCategoryValues = this.transferHttp.getSingle('hr/GetJobCategoriesTable');
  unionAffiliationValues = this.transferHttp.getSingle('hr/GetUnionAffiliation');

  newWorkSections() {
    return new WorkSections();
  }

  newDepartments() {
    return new Departments();
  }

  newJobTitles() {
    return new JobTitles();
  }

  constructor(
    private transferHttp: TransferHttpService,
    public permissions: PermissionsService,
    public mainGridService: MainGridService<any>
  ) {
    this.tablePermissions.create = permissions.canCreate(permissions.ComponentID.HumanResourcesConfig);
    this.tablePermissions.update = permissions.canUpdate(permissions.ComponentID.HumanResourcesConfig);
    this.workSections = this.mainGridService.getAll('Hr/GetWorkSections', 'Hr/SaveWorkSections');

    this.mainDepartmentsService = new MainGridService<any>(this.transferHttp);
    this.departments = this.mainDepartmentsService.getAll('Hr/GetDepartments', 'Hr/SaveDepartments');
    this.departments.subscribe(data => this.departmentsResults = data);

    this.mainJobTitlesService = new MainGridService<any>(this.transferHttp);
    this.jobTitles = this.mainJobTitlesService.getAll('Hr/GetJobTitles', 'Hr/SaveJobTitles');
    this.jobTitles.subscribe(data => this.jobTitlesResults = data)

  }

  ngOnInit(): void {
    this.initialTableElement = this.newWorkSections();
    this.initialDepartmentsTableElement = this.newDepartments();
    this.initialJobTitlesTableElement = this.newJobTitles();
  }

  handleRowUpdate(update: TableRowUpdate): void {
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe());
  }

  handleRowAdd(update: TableRowUpdate): void {
    this.mainGridService.add(update.newRow).subscribe(update.handleSubscribe());
  }

  handleDepartmentsRowUpdate(update: TableRowUpdate): void {
    this.mainDepartmentsService.updateByObject(update.newRow, update.oldRow).subscribe(update.handleSubscribe());
  }

  handleDepartmentsRowAdd(update: TableRowUpdate): void {
    this.mainDepartmentsService.add(update.newRow).subscribe(update.handleSubscribe());
  }

  handleJobTitlesRowUpdate(update: TableRowUpdate): void {
    this.mainDepartmentsService.updateByObject(update.newRow, update.oldRow).subscribe(update.handleSubscribe());
  }

  handleJobTitlesRowAdd(update: TableRowUpdate): void {
    this.mainDepartmentsService.add(update.newRow).subscribe(update.handleSubscribe());
  }

  ngOnDestroy() {
  }
}
